<template>
  <b-dropdown ref="dropdown"
              variant="link"
              toggle-class="MenuModules text-decoration-none"
              :no-caret="true">
    <template v-slot:button-content>
      <div class="MenuModules_wrap">
        <svg class="header_logo icon--sm"
             role="presentation">
          <use :xlink:href="'#' + appsIcon.id" />
        </svg>
      </div>
    </template>

    <div v-for="(module, index) in modules"
         :key="index"
         class="m-0 p-0">
      <b-dropdown-item v-ripple
                       class="MenuModules_list"
                       @click="click(`${module.path}?token=${userToken}`)">
        <svg class="MenuModules_list_icon icon--full"
             :class="{ 'ml-0 pl-3 pr-3 mr-0': module.name === 'Sofia Rei' }"
             role="presentation">
          <use :xlink:href="'#' + module.logo.id" />
        </svg>
      </b-dropdown-item>
      <b-dropdown-divider v-if="index + 1 != modules.length" />
    </div>
  </b-dropdown>
</template>

<script>
  import { mapGetters } from "vuex"

  /* icons */
  import appsIcon from '@/assets/icons/apps.svg?sprite'
  import sofiaReiLogo from '@/assets/icons/rei.svg?sprite'
  import eSinoregLogo from '@/assets/icons/SINOREG/sinoreg_sp.svg?sprite'

  /* service */
  import MigracaoService from '@/services/MigracaoService'

  export default {
    name: "MenuModules",
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        userToken: 'auth/getUserToken'
      })
    },
    data () {
      return {
        appsIcon,
        sofiaReiLogo,
        eSinoregLogo,
        modules: [
          { name: 'Sofia Rei', path: '/', logo: sofiaReiLogo }
        ],
        recovery: null
      }
    },
    async mounted () {
      this.recovery = await MigracaoService.getMigracaoByCartorio(this.cartorioId)

      // Só liberamos o acesso ao esinoreg(barramento) para os cartórios que estiverem com o recovery completo
      if (this.recovery && this.recovery.status === 'COMPLETED') {
        this.modules.push({
          name: 'eSinoreg',
          path: `${process.env.VUE_APP_ESINOREG_CLIENT_URL}/login`,
          logo: this.eSinoregLogo
        })
      }
    },
    methods: {
      click (path) {
        this.$refs.dropdown.hide(true)

        if (path.search('http') >= 0) {
          return window.open(path)
        }

        if (this.$route.name !== 'rei_dashboard') {
          this.$router.push(path)
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '@/scss/_utilities/_exports';

  .MenuModules {
    background-color: transparent;
    border: pxToRem(1) solid;
    border-color: transparent $color-gray-light;
    max-height: pxToRem(50);
    margin: 0 pxToRem(8);
    width: 60px !important;

    &.dropdown-toggle:after {
      content: '';
      display: none;
    }

    > ul.dropdown-menu {
      left: -50px !important;
    }

    &_list a {
      margin: 0;
      padding: 15px;
      height: 100px;

    }

    &_list a:active {
      background-color: $color-gray-light !important;
    }

    &:hover,
    &:active {
      background-color: transparent !important;
      border-color: transparent $color-gray-light !important;
    }

    @media(min-width: pxToRem(400)) {
      width: pxToRem(132);

      &_content {
        display: inline-block;
        @include calc(width, '100% - #{pxToRem(40)}', null);
      }
    }

    @media(min-width: pxToRem(568)) {
      margin: 0 pxToRem(12);
      padding: 0 pxToRem(12);
      width: pxToRem(180);
    }

    @media(min-width: pxToRem(1024)) {
      width: pxToRem(192);
    }
  }
</style>
